export enum DonorSelfRegistrationStatus {    
    PendingCertifications = 1,
    PendingReferral = 5,
    PendingSurgery = 6,
    PendingWorkup = 7,
    Donated = 8
}